// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2QEtA","messages":"Chat_messages__3akay","dateDivider":"Chat_dateDivider__1G-CL"};